import { Component } from '@angular/core';

@Component({
  selector: 'app-balance-on',
  templateUrl: './balance-on.component.html',
  styleUrls: ['./balance-on.component.scss']
})
export class BalanceOnComponent {

}
